import { Injectable, signal } from '@angular/core';

export type TipoToast = 'success' | 'error' | 'warning' | 'info';

export interface Toast {
  mensaje: string;
  clase: string;
  icono: string;
}

const ESTILOS: Record<TipoToast, Pick<Toast, 'clase' | 'icono'>> = {
  success: { clase: 'alert-success', icono: 'ph ph-check-circle' },
  error: { clase: 'alert-error', icono: 'ph ph-x-circle' },
  warning: { clase: 'alert-warning', icono: 'ph ph-warning' },
  info: { clase: 'alert-info', icono: 'ph ph-info' },
};
const DURACION_MS = 3200;

// Un aviso a la vez: el nuevo reemplaza al anterior.
@Injectable({ providedIn: 'root' })
export class ToastService {
  readonly actual = signal<Toast | null>(null);
  private temporizador?: ReturnType<typeof setTimeout>;

  exito(mensaje: string): void {
    this.mostrar(mensaje, 'success');
  }

  error(mensaje: string): void {
    this.mostrar(mensaje, 'error');
  }

  aviso(mensaje: string): void {
    this.mostrar(mensaje, 'warning');
  }

  info(mensaje: string): void {
    this.mostrar(mensaje, 'info');
  }

  private mostrar(mensaje: string, tipo: TipoToast): void {
    clearTimeout(this.temporizador);
    this.actual.set({ mensaje, ...ESTILOS[tipo] });
    this.temporizador = setTimeout(() => this.actual.set(null), DURACION_MS);
  }
}
